import { useNewsContext } from "../../contexts/news";
import SEO from "./SEO";
import SEOConfig, { publisherRef } from "./SEOConfig";

const NewsListSEO = ({ url }) => {
  const { posts } = useNewsContext();

  const title = "Новини симрейсингу";
  const description =
    "Останні новини симрейсинг-ліги Slick Racing Ukraine: анонси етапів, підсумки гонок в iRacing, інтерв'ю з пілотами та аналітика.";

  const firstPost = posts && posts.length > 0 ? posts[0] : null;
  const firstPostImage = firstPost?.mainImage?.data?.attributes?.url;

  const { siteUrl } = SEOConfig;
  const fullUrl = url.startsWith("http") ? url : `${siteUrl}${url}`;
  // No post image yet → undefined, and SEO.jsx falls back to og-default.png.
  const fullImageUrl = firstPostImage || undefined;

  // Add relevant keywords for the news page
  const keywords = [
    "Slick Racing Ukraine",
    "симрейсинг новини",
    "сімрейсінг новини",
    "віртуальний автоспорт",
    "iRacing",
    "українська ліга",
  ];

  // Define breadcrumbs for better navigation and SEO
  const breadcrumbs = [
    {
      name: "Головна",
      url: siteUrl,
    },
    {
      name: "Новини",
      url: fullUrl,
    },
  ];

  // Create structured data for the news list
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    headline: title,
    description: description,
    image: fullImageUrl,
    url: fullUrl,
    dateModified: firstPost ? firstPost.updatedAt : new Date().toISOString(),
    publisher: publisherRef,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": fullUrl,
    },
  };

  // Add ItemList of articles if we have posts
  if (posts && posts.length > 0) {
    schema.mainEntity = {
      "@type": "ItemList",
      itemListElement: posts.slice(0, 10).map((post, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${siteUrl}/news/${post.id}`,
        name: post.title,
        description: post.excerpt || post.title,
        image: post.mainImage?.data?.attributes?.url,
        datePublished: post.publishedAt || post.createdAt,
      })),
    };
  }

  return (
    <SEO
      title={title}
      description={description}
      keywords={keywords}
      image={fullImageUrl}
      url={fullUrl}
      schema={schema}
      canonical={fullUrl}
      type="website"
      breadcrumbs={breadcrumbs}
      lang="uk"
    />
  );
};

export default NewsListSEO;
